import React, { useContext } from "react";

import { Grid, Typography, Box, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";

import { useMediaQuery } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HealingIcon from "@mui/icons-material/Healing";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import InfoIcon from "@mui/icons-material/Info";

import ChildCard from "./ChildCard";
import ChildDetailsCard from "./ChildDetailsCard";
import EnrolmentCard from "./EnrolmentCard";
import ObservationCard from "./ObservationCard";
import NewsCard from "./NewsCard";
import AccidentCard from "./AccidentCard";

import { IChild } from "./types/child";
import { byDateDesc } from "../util";

type ActiveTab = "observations" | "news" | "accidents" | "details";
const tabs: ActiveTab[] = ["observations", "news", "accidents", "details"];
const Content: React.FC<{ activeTab: ActiveTab, child: IChild }> = ({ activeTab, child }) => {
  return (
    <Box sx={{ padding: 2 }}>
      {activeTab === "observations" && (
        <Grid container spacing={3} style={{ height: "100%" }}>
          <Grid item xs={12}>
            <Typography variant="h4" component="div">
              Observations
            </Typography>
          </Grid>
          {child.observations
            .sort((a: any, b: any) => (new Date(b.observationDate) as any) - (new Date(a.observationDate) as any))
            ?.map((observation: any) => (
              <Grid item xs={12}>
                <ObservationCard observation={observation} />
              </Grid>
            ))}
          {child.observations && child.observations.length < 1 && (
            <Grid item xs={12}>
              <Typography variant="h6" component="div">
                No observations reported.
                <br />
                <Typography variant="body1" component="div">
                  Watch this space for updates.
                </Typography>
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
      {activeTab === "news" && (
        <Grid container spacing={3} style={{ height: "100%" }}>
          <Grid item xs={12}>
            <Typography variant="h4" component="div">
              News
            </Typography>
          </Grid>
          {child.news?.sort(byDateDesc(x => x.date))?.map((article: any) => (
            <Grid item xs={12}>
              <NewsCard article={article} />
            </Grid>
          ))}
        </Grid>
      )}
      {activeTab === "accidents" && (
        <Grid container spacing={3} style={{ height: "100%" }}>
          <Grid item xs={12}>
            <Typography variant="h4" component="div">
              Accidents
            </Typography>
          </Grid>
          {child.accidents?.map((accident: any) => (
            <Grid item xs={12}>
              <AccidentCard accident={accident} />
            </Grid>
          ))}
          {child.accidents && child.accidents.length < 1 && (
            <Grid item xs={12}>
              <Typography variant="h6" component="div">
                No accidents reported.
                <br />
                <Typography variant="body1" component="div">
                  Great job! Let's keep it that way.
                </Typography>
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
      {activeTab === "details" && (
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <ChildCard child={child} />
          </Grid>
          <Grid item xs={12} lg={4}>
            <ChildDetailsCard child={child} />
          </Grid>
          <Grid item xs={12} lg={4}>
            <EnrolmentCard enrolment={child.registration.enrolment} />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

const ChildView: React.FC<{ child: IChild }> = ({ child }) => {


  const [bottomNavValue, setBottomNavValue] = React.useState(0);
  const isMobile = useMediaQuery("(max-width: 1280px)");

  return (
    <React.Fragment>

      {isMobile ? (
        <Box sx={{ flex: 1, marginBottom: "60px" }}>
          <Content activeTab={tabs[bottomNavValue]} child={child} />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column">

          <Content activeTab={"details"} child={child} />

          <Grid
            style={{ marginTop: "20px" }}
            container
            spacing={3}
            alignItems="flex-start"
            justifyItems="center"
            justifyContent="center"
            justifySelf="center"
          >
            <Grid item xs={4}>
              <Content activeTab={"observations"} child={child} />
            </Grid>


            <Grid item xs={4}>
              <Content activeTab={"accidents"} child={child} />
            </Grid>

            <Grid item xs={4}>
              <Content activeTab={"news"} child={child} />
            </Grid>
          </Grid>
        </Box>
      )}

      {isMobile && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
          <BottomNavigation
            showLabels
            value={bottomNavValue}
            onChange={(event, newValue) => {
              setBottomNavValue(newValue);
            }}
          >
            <BottomNavigationAction label="Observations" icon={<VisibilityIcon />} />
            <BottomNavigationAction label="News" icon={<NewspaperIcon />} />
            <BottomNavigationAction label="Accidents" icon={<HealingIcon />} />
            <BottomNavigationAction label="Details" icon={<InfoIcon />} />
          </BottomNavigation>
        </Paper>
      )}

    </React.Fragment >
  );
};

export default ChildView;
